import React, { useContext } from "react";
import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context.ts";
import { FormFieldTitle } from "features/bots/common/styles.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";
import { LanguageNameSpaces } from "@shared/types";
import { isSymbol } from "@shared/types/utils.ts";
import { HEDGING_LONG_INPUT_ID, HEDGING_SHORT_INPUT_ID } from "testIds.ts";
import HedgingRatioSelector from "features/bots/BotForm/Entries/HedgingRatioSelector.tsx";

interface HedgingSelectorProps {
  hideTitle?: boolean;
}

const HedgingSelector = ({ hideTitle }: HedgingSelectorProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BOTS);
  const { longHedgingRatio, setLongHedgingRatio } = useContext(BotFormContext)!;
  const isMultiValue = isSymbol(longHedgingRatio);

  return (
    <div>
      {!hideTitle && <FormFieldTitle>{t("labels.hedging")}</FormFieldTitle>}
      <HedgingRatioSelector
        longHedgingRatio={isMultiValue ? undefined : longHedgingRatio}
        setLongHedgingRatio={setLongHedgingRatio}
        isMultiValue={isMultiValue}
        longInputTestId={HEDGING_LONG_INPUT_ID}
        shortInputTestId={HEDGING_SHORT_INPUT_ID}
        useFormFieldTitles={true}
      />
    </div>
  );
};

export default React.memo(HedgingSelector);
